"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var IconCSS_1 = require("./IconCSS");
var IconFont_1 = require("./IconFont");
var IconSVGFile_1 = require("./IconSVGFile");
var IconSVGInline_1 = require("./IconSVGInline");
var Icon = function (props) {
    var children = props.children, _a = props.className, className = _a === void 0 ? '' : _a, iconClassName = props.iconClassName, isInline = props.isInline, isRHS = props.isRHS, screenreader = props.screenreader, symbol = props.symbol, svgArgs = props.svgArgs, theme = props.theme, type = props.type, attributes = __rest(props, ["children", "className", "iconClassName", "isInline", "isRHS", "screenreader", "symbol", "svgArgs", "theme", "type"]) // tslint:disable-line
    ;
    var iconname = symbol;
    var isBankwest = theme && theme.toLowerCase() === 'bankwest';
    var iconlist = isBankwest ? honeycomb_1.BWIcons.IconList : honeycomb_1.Icons.IconList;
    if (typeof iconlist[symbol] === 'undefined') {
        var regex_1 = new RegExp("^" + symbol + "(.(?!.Args$))+$");
        var similarIcons = Object
            .keys(iconlist)
            .filter(function (candidateIconname) {
            return regex_1.test(candidateIconname);
        });
        if (similarIcons.length > 0) {
            iconname = similarIcons[0];
        }
        else {
            return null;
        }
    }
    // Add wrapper classnames
    var wrapperClassName = (0, classnames_1.default)('icon-wrapper', className !== null && className !== void 0 ? className : className, {
        'icon-inline': isInline,
        'icon-sm': iconname.indexOf('16') > -1,
    });
    // adding icon className
    var iconClassNames = (0, classnames_1.default)(iconClassName !== null && iconClassName !== void 0 ? iconClassName : iconClassName, {
        'ml-1': isRHS,
    });
    var textClassNames = (0, classnames_1.default)({ 'ml-1': !isRHS });
    var image = null;
    switch (type) {
        case 'svgfile':
            image = (React.createElement(IconSVGFile_1.IconSVGFile, { symbol: iconname, className: iconClassNames, theme: theme }));
            break;
        case 'svginline':
            image = (React.createElement(IconSVGInline_1.IconSVGInline, { symbol: iconname, className: iconClassNames, args: svgArgs, theme: theme }));
            break;
        case 'css':
            image = (React.createElement(IconCSS_1.IconCSS, { symbol: iconname, className: iconClassNames, theme: theme }));
            break;
        case 'iconfont':
            image = (React.createElement(IconFont_1.IconFont, { symbol: iconname, className: iconClassNames }));
            break;
    }
    // Create an child element for the icon wrapper
    var component = (React.createElement(React.Fragment, null,
        !isRHS && image,
        children && (React.createElement("span", { className: textClassNames }, children)),
        screenreader && (React.createElement("span", { className: "sr-only" }, screenreader)),
        isRHS && image));
    if (props.href) {
        return (React.createElement("a", __assign({ className: wrapperClassName }, attributes), component));
    }
    else if (typeof props.onClick !== 'undefined') {
        return (React.createElement("button", __assign({ className: wrapperClassName, type: "button" }, attributes), component));
    }
    else {
        return (React.createElement("span", __assign({ className: wrapperClassName }, attributes), component));
    }
};
exports.Icon = Icon;
/* tslint:disable:no-string-literal */
exports.Icon['defaultProps'] = {
    className: '',
    iconClassName: '',
    screenreader: '',
    symbol: 'controlSearch24',
    type: 'svgfile',
};
exports.Icon['propTypes'] = {
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    className: function (props) {
        if (typeof props.className !== 'string') {
            return new Error('The icon classname should be a string');
        }
        if (props.className && props.className.indexOf('icon-wrapper') !== -1) {
            return new Error('The icon classname cannot include "icon-wrapper"');
        }
        return;
    },
    href: PropTypes.string,
    iconClassName: function (props) {
        if (typeof props.iconClassName !== 'string') {
            return new Error('The icon iconClassName should be a string');
        }
        if (props.iconClassName && props.iconClassName.indexOf('hc-icon') !== -1) {
            return new Error('The icon iconClassName cannot include "hc-icon"');
        }
        if (props.href && props.onClick) {
            return new Error('The icon should not contain both a "href" and an "onClick" prop.');
        }
        return;
    },
    isInline: PropTypes.bool,
    isRHS: PropTypes.bool,
    onClick: PropTypes.func,
    screenreader: PropTypes.string,
    svgArgs: PropTypes.object,
    symbol: PropTypes.oneOf(Object.keys(__assign(__assign({}, honeycomb_1.Icons.IconList), honeycomb_1.BWIcons.IconList)).filter(function (iconname) {
        if (iconname.match(/Args$/)) {
            return false;
        }
        return true;
    })),
    theme: PropTypes.string,
};
/* tslint:enable:no-string-literal */
